import { Staff } from "@/api/company-api";
import { ServiceUser } from "@/api/service-api";

export default class InvitableStaffSpec {
  constructor(private serviceUsers: ServiceUser[]) {}

  isSatisfied(s: Staff) {
    return !this.serviceUsers.some(su => su.staffId === s.staffId);
  }
}
